import $ from 'jquery';
import { MindboxCarousel } from './mindbox-carousel';

export class MindboxCartRelatedRecommendations {
    constructor() {
        this.container = $('[data-mindbox-product="cart-related"]');
    }

    init() {
        if (this.container.length === 0) {
            return;
        }

        let _self = this;
        $.ajax({
            url: '/ajax/action/widget_mindbox_products/get_cart_related_products/',
            data: {},
            type: 'GET',
            success: function(result) {
                if (result.data.status !== 'ok') {
                    console.log('mindbox box not render');
                    return;
                }

                _self.container.html(result.html);
                MindboxCarousel.init(_self.responsiveOptions());
            }
        });
    }

    responsiveOptions() {
        return {
            0: {
                items: 2,
                dots: true
            },
            481: {
                items: 2,
                dots: true
            },
            768: {
                items: 3,
                nav: true
            },
            992: {
                items: 3,
                nav: true
            },
            1200: {
                items: 5,
                nav: true
            }
        };
    }
}

jQuery(function() {
    new MindboxCartRelatedRecommendations().init();
});



// WEBPACK FOOTER //
// ./modules/mindbox/mindbox-cart-related-recommendations.js